import { DateRangePicker } from '@progress/kendo-react-dateinputs'
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { GridColumn } from '@progress/kendo-react-grid'
import 'components/content-pool/_styles.scss'
import { TitleCell } from 'components/content-pool/kendocells'
import { DropdownComponent, DropdownOption} from 'components/dropdown/component'
import { HeaderComponent } from 'components/header/component'
import { Articles } from 'components/icons/articles'
import { RasaContext } from 'context'
import { DateRangeFilter, esToNormalDateRange, IndexName, SizeFilterDropdownOptions,
  SourceNameOptions, SuspectFilterDropdownOptions, toFilter } from 'elasticsearch/constants'
import { DateRangesAsDropdownOptions } from 'elasticsearch/constants'
import {
  ElasticsearchProps,
} from 'generic/elasticSearchComponent'
import * as GenericRedux from 'generic/genericRedux'
import * as React from 'react'
import { Button } from 'reactstrap'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import { Chart, ChartSeries, ChartSeriesItem, ChartCategoryAxis, ChartCategoryAxisItem, ChartTitle } from '@progress/kendo-react-charts'
import { PDFReportHeader } from './PDFReportHeader'
import { SharedKeys, SharedStore } from 'shared/data-layer/sharedStore'
import { RasaAnalyticsComponent } from './rasa-analytics-component'
import { Dataset } from 'generic/dataset'
import { SourceSection } from 'components/content-pool/types'
import { ShareCell } from './share-cell'
import './styles.css'
import * as Utils from './utils'
import { ConnectedComponentClass } from 'react-redux'
import { ComponentType } from 'react'
import {Fields} from "../../shared/modals";
import { RasaReactComponent } from 'generic/rasaReactComponent'
import { PagingSource, RasaDataGrid } from 'generic/rasaDataGrid'

export class ArticlesComponent extends RasaAnalyticsComponent<any, any> {

  constructor(props) {
    super(props)
    this.state = {
      ...this.state,
      sections: [],
      selectedSection: { key: '0', value: 'all', description: 'All Sections' },
    }
  }

  public componentDidMount() {
    super.componentDidMount()
    this.minCustomDateRange()
    // Load sections for filtering using the same pattern as base class
    this.sharedStore = SharedStore.instance(this.context)
    this.sharedStore.getValue(SharedKeys.activeCommunity).then((activeCommunity) => {
      this.getSections(activeCommunity.communityId)
    }).catch((error) => {
      // Error loading sections
    })
  }

  private getSections = (communityId) => {
    new Dataset()
      .loadCommunityDataset('sections', communityId)
      .then((response) => {
        const sections = response[0] || []
        this.setState({
          sections: this.normalizeSectionsForFilter(sections)
        })
      })
  }

  private normalizeSectionsForFilter = (sections: SourceSection[]): DropdownOption[] => {
    const normalizedSections = sections.map((s) => ({
      description: s.display_name,
      key: s.id.toString(),
      value: s.name, // ES field is section_name which maps to section.name (not display_name)
    }))
    // Add "All Sections" option at the top
    normalizedSections.unshift({ 
      description: 'All Sections', 
      key: '0', 
      value: 'all' 
    })
    return normalizedSections
  }

  sectionChanged = (e: any) => {
    this.setState({
      selectedSection: e.selected,
    })
  }

  public render() {
    return(
      <div className="analytics-component">
        <HeaderComponent
          title={'ANALYTICS'}
          subTitle={'Articles'}
          description={['The articles your contacts are clicking on the most.']}
        />
        <div className="dropdown articles">
          <div className="grid-container">
            <DropdownComponent data={DateRangesAsDropdownOptions}
                                selected={this.state.selectedDateRange.key}
                                onChange={this.dateChanged}/>
            <DropdownComponent data={SuspectFilterDropdownOptions}
                                selected={this.state.selectedSuspectClick.key}
                                onChange={this.suspectedClickChanged}/>
          </div>
          <div className="grid-container">
            <div><span>Source Name</span>
              <DropdownComponent data={SourceNameOptions}
                                selected={this.state.selectedSourceName.key}
                                onChange={this.sourceClickChanged}/>
            </div>
            <div><span>Section</span>
              <DropdownComponent data={this.state.sections}
                                selected={this.state.selectedSection.key}
                                onChange={this.sectionChanged}/>
            </div>
          </div>
          <div className="grid-container">
            <div><span>Articles Count</span>
            <DropdownComponent data={SizeFilterDropdownOptions}
                                selected={this.state.selectedSize.key}
                                onChange={this.sizeChanged}/>
            </div>
          </div>
          <div className="date-range-picker">
              {this.state.selectedDateRange.key === '7' ?
              <DateRangePicker onChange={this.createCustomDate}
                               min={this.state.minCustomDateRange}
                               max ={new Date()} /> : null}
            </div>
        </div>
      {this.state.isFilterLoaded &&
        <AnalyticsArticlesTable 
              key={`${this.state.selectedDateRange.value}-${this.state.selectedSuspectClick.value}-${this.state.selectedSourceName.value}-${this.state.selectedSection.value}-${this.state.selectedSize.value}`}
              dateRange={this.state.selectedDateRange.value}
              dateRangeLabel={this.state.selectedDateRange.description}
              size={this.state.selectedSize.value} from={1} timezone={this.state.timezone}
              useTimezoneForAnalytics={this.state.useTimezoneForAnalytics}
              suspectClick={this.state.selectedSuspectClick.value} sourceName={this.state.selectedSourceName.value}
              sectionName={this.state.selectedSection.value}/>}
    </div>
    )
  }

}

interface ArticleStats {
  opens?: number,
  post_id: string,
  realClicks?: number,
  realUniqueRate?: number,
  realUniqueCount?: number,
  sourceName?: string,
  suspectClick?: number,
  suspectUniqueRate?: number,
  suspectUniqueCount?: number,
  totalClicks?: number,
  totalUniqueRate?: number,
  totalUniqueCount?: number,
  uniqueClicks: number,
}

interface PostInfo {
  custom_tags?: string,
  nlp_tags?: string,
  source_tags?: string,
  post_id?: string,
  title?: string,
  url?: string,
}

type Article = ArticleStats & PostInfo

type Articles = Article[]

interface ArticlesState {
  loaded: boolean,
  communityGuid: string,
  shareUrl: string,
  shortenUrl: string,
  user: any,
  results: any[],
  isLoadingData: boolean,
}

interface ArticlesProps extends ElasticsearchProps<Articles> {
  dateRange: any,
  offset: any,
  size: any,
  suspectClick?: any,
  sourceName?: any,
  sectionName?: any,
  timezone?: string,
  useTimezoneForAnalytics?: any,
  dateRangeLabel?: string
}

class ArticlesTableComponent extends RasaReactComponent<ArticlesProps, ArticlesState> {
  public static contextType = RasaContext
  private sharedStore: SharedStore
  private xlsxExport: any = null
  private pdfExportRef: React.RefObject<HTMLDivElement> = React.createRef()
  constructor(p: ArticlesProps) {
    super(p, IndexName.EVENTS)
    this.state = {
      isDirty: false,
      isLoading: false,
      isSaving: false,
      loaded: false,
      communityGuid: '',
      results: [],
      shareUrl: '',
      shortenUrl: '',
      user: {},
      isLoadingData: false,
    }
  }
  public componentDidMount() {
    this.setState({ isLoadingData: true })
    this.sharedStore = SharedStore.instance(this.context)
    Promise.all([
      this.sharedStore.getValue(SharedKeys.activeCommunity),
      this.sharedStore.getValue(SharedKeys.person),
      this.sharedStore.getValue(SharedKeys.config),
    ]).then(([activeCommunity, person, config]) => {
      this.setState({
        communityGuid: activeCommunity.data.community_guid,
        shortenUrl: config.shortenUrl,
        shareUrl: config.shareUrl,
        user: {
          email: person.email,
          firstName: person.firstName,
          lastName: person.lastName,
        },
      })
    })
  }

  public exportToPDF = async () => {
    if (!this.pdfExportRef.current) return

    try {
      const element = this.pdfExportRef.current

      // Temporarily add PDF export mode class to show PDF elements
      element.classList.add('pdf-export-mode')

      // Wait a brief moment for styles to apply
      await new Promise(resolve => setTimeout(resolve, 100))

      const pdf = new jsPDF('l', 'mm', 'a4') // landscape orientation
      const pdfWidth = pdf.internal.pageSize.getWidth()
      const pdfHeight = pdf.internal.pageSize.getHeight()

      // Capture header and chart separately (Page 1)
      const headerChart = element.querySelector('.pdf-header-chart-section')
      if (headerChart) {
        const headerCanvas = await html2canvas(headerChart as HTMLElement, {
          height: headerChart.scrollHeight,
          width: headerChart.scrollWidth,
          useCORS: true,
          scale: 2
        })

        const headerImgData = headerCanvas.toDataURL('image/png')
        const headerRatio = Math.min(pdfWidth / headerCanvas.width, pdfHeight / headerCanvas.height)
        const headerImgX = (pdfWidth - headerCanvas.width * headerRatio) / 2

        pdf.addImage(headerImgData, 'PNG', headerImgX, 10, headerCanvas.width * headerRatio, headerCanvas.height * headerRatio)
      }

      // Capture table separately (Page 2+)
      if (this.state.results && this.state.results.length > 0) {
        const itemsPerPage = 15
        const totalPages = Math.ceil(this.state.results.length / itemsPerPage)

        for (let page = 0; page < totalPages; page++) {
          pdf.addPage()

          // Add page header
          pdf.setFontSize(16)
          pdf.text(`Articles Report - Page ${page + 2} of ${totalPages + 1}`, 20, 20)
          pdf.setFontSize(12)
          pdf.text(`Showing entries ${page * itemsPerPage + 1} - ${Math.min((page + 1) * itemsPerPage, this.state.results.length)} of ${this.state.results.length}`, 20, 30)

          // Create table data for this page
          const pageData = this.state.results.slice(page * itemsPerPage, (page + 1) * itemsPerPage)

          // Simple table rendering
          let yPosition = 50
          const rowHeight = 7
          const colPositions = [20, 120, 180, 220, 260]

          // Table headers
          pdf.setFontSize(9)
          pdf.setFont(undefined, 'bold')
          pdf.text('Title', colPositions[0], yPosition)
          pdf.text('Source', colPositions[1], yPosition)
          pdf.text('Opens', colPositions[2], yPosition)
          pdf.text('Total Clicks', colPositions[3], yPosition)
          pdf.text('Unique Clicks', colPositions[4], yPosition)
          yPosition += rowHeight + 2

          // Table rows
          pdf.setFont(undefined, 'normal')
          pageData.forEach((item: any) => {
            if (yPosition > pdfHeight - 20) return // Stop if near bottom of page

            pdf.text(item.title ? item.title.substring(0, 35) : 'Untitled', colPositions[0], yPosition)
            pdf.text(item.sourceName ? item.sourceName.substring(0, 20) : 'N/A', colPositions[1], yPosition)
            pdf.text((item.opens || 0).toString(), colPositions[2], yPosition)
            pdf.text((item.totalClicks || 0).toString(), colPositions[3], yPosition)
            pdf.text((item.uniqueClicks || 0).toString(), colPositions[4], yPosition)
            yPosition += rowHeight
          })
        }
      }

      // Remove PDF export mode class
      element.classList.remove('pdf-export-mode')

      pdf.save('articles-report.pdf')
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error generating PDF:', error)
      // Make sure to remove the class even if there's an error
      if (this.pdfExportRef.current) {
        this.pdfExportRef.current.classList.remove('pdf-export-mode')
      }
    }
  }

  public render = () => {
    const dateRangeFilter: DateRangeFilter = toFilter(this.props.dateRange)
    const displayClickType: any = Utils.getDisplayedClickType(this.props.suspectClick)
    const sourceTitle: any = this.props.sourceName === SourceNameOptions[0].value ?
    'Source' :
    'Publisher'
    return <div>
      <div className="articles-chart">

        <div className="articles">
        {this.state.results && this.state.results.length > 0 ?
        <div className="articles-export-buttons">
          <Button
            disabled={this.state.results.length < 1 || this.state.isLoadingData}
            onClick={() => this.xlsxExport.save()}>
            Export xlsx
          </Button>
          <Button
            color="secondary"
            disabled={this.state.results.length < 1 || this.state.isLoadingData}
            onClick={this.exportToPDF}>
            Export PDF
          </Button>
        </div> : null}
          <div ref={this.pdfExportRef}>
            <div className="pdf-header-chart-section">
              <PDFReportHeader
                title="Articles Report"
                dateRange={esToNormalDateRange(this.props.dateRange)}
                dateRangeLabel={this.props.dateRangeLabel}
                fields={[
                  { label: 'Suspect Click Filter', value: Utils.getDisplayedClickType(this.props.suspectClick).title },
                  { label: 'Source Name', value: this.props.sourceName },
                  { label: 'Section Filter', value: this.props.sectionName === 'all' ? 'All Sections' : this.props.sectionName },
                ]}
                analysis="Top performing articles by click engagement"
              />

              {this.state.results && this.state.results.length > 0 && (
                <div className="pdf-chart-section">
                  <h3>Top 20 Articles - Total vs Unique Clicks</h3>
                  <Chart style={{ height: '400px' }}>
                    <ChartTitle text="Article Performance Comparison" />
                    <ChartCategoryAxis>
                      <ChartCategoryAxisItem
                        categories={this.state.results.slice(0, 20).map((item: any) =>
                          item.title ? item.title.substring(0, 30) + '...' : 'Untitled'
                        )}
                        labels={{ rotation: -45 }}
                      />
                    </ChartCategoryAxis>
                    <ChartSeries>
                      <ChartSeriesItem
                        type="column"
                        data={this.state.results.slice(0, 20).map((item: any) => item.totalClicks || 0)}
                        name="Total Clicks"
                        color="#8fd1bb"
                      />
                      <ChartSeriesItem
                        type="column"
                        data={this.state.results.slice(0, 20).map((item: any) => item.uniqueClicks || 0)}
                        name="Unique Clicks"
                        color="#fcc3a7"
                      />
                    </ChartSeries>
                  </Chart>
                </div>
              )}
            </div>

            <div className="pdf-table-section">
              <h3>Detailed Article Performance</h3>
            </div>
          </div>
          <ExcelExport data={this.state.results}
            fileName="RasaSourceReports.xlsx"
            ref={(exporter) => {this.xlsxExport = exporter}}>
            <RasaDataGrid
              // Rasa Properties for entity, datasetName etc
              entityName="articleDetails"
              datasetName="articleDetails"
              datasetParams={[
                { param: 'gte', value: encodeURIComponent(dateRangeFilter.gte) },
                { param: 'lt', value: encodeURIComponent(dateRangeFilter.lt) },
                { param: 'normalDateRange', value: encodeURIComponent(esToNormalDateRange(this.props.dateRange))},
                { param: 'timezone', value: encodeURIComponent(this.props.timezone)},
                { param: 'excludeSuspectClick', value: Utils.isRealClickSelected(this.props.suspectClick) },
                { param: 'size', value: Number(this.props.size) || 100 },
                { param: 'sourceName', value: this.props.sourceName },
                { param: 'sectionName', value: this.props.sectionName },
                { param: 'useTimezoneForAnalytics', value: this.props.useTimezoneForAnalytics },
              ]}
              editDefaultState={false}
              // events
              onDataReceived={this.dataReceived}
              sortable={true}
              pagingSource={PagingSource.local}
              pageable={true}
              pageSize={50}
              data={[]}>
              <GridColumn field="sourceName" title={sourceTitle} width={250} />
              <GridColumn field="title" title="Title" cell={this.ClickableTitleCell} width={450}/>
              <GridColumn field="opens" title="Opens" width={120}/>

              <GridColumn field={displayClickType.field} title={displayClickType.title} width={120} />
              <GridColumn field="uniqueClicks" title="Unique Clicks" width={120}/>
              <GridColumn field="uniqueClickRate" title="Unique Click Rate" width={0}/>

              <GridColumn cell={ShareCell} field="url" title="Share" width={150}/>
            </RasaDataGrid>
          </ExcelExport>
        </div>
      </div>
    </div>
  }
  private dataReceived = (data) => {
		if (data.data) {
			this.setState({
				results: data.data,
				isLoadingData: false,
			})
		}
	}
  private ClickableTitleCell = (props: any) => {
    return <TitleCell {...props} onClick={(e) => {this.openLink(e)}} />
  }
  private openLink = (p: any) => {
    window.open(p.url, '_blank')
  }
}

export const AnalyticsArticlesTable: ConnectedComponentClass<ComponentType<ArticlesTableComponent>, Fields> = GenericRedux.registerNewComponent(
  ArticlesTableComponent, 'home_articles', {})
